import * as constants from '~/constants/index'

export default defineNuxtPlugin((nuxtApp) => { 
  return {
    provide: {
      constants
    }
  }
})